<template lang="html">
  <div class="studio-shot col-three sortable-item" :data-resource-id="shot.id">
    <div class="shot-content">
      <div class="shot-thumbnail">
        <img :src="this.shot.imagePath" alt="Studio shot" data-rjs="2">
      </div>
      <div class="col-twelve text-left shot-toolbar">
        <button class="transparent-button" @click="deleteShot">Delete</button>
      </div>
    </div>
  </div>
</template>

<script>
// Component to show studio shot

export default {
  props: ['shot'],
  methods: {
    deleteShot() {
      if (confirm('Are sure you want to delete this content?')) {
        axios.post('/profile/ajax/delete/shot', {
          id: this.shot.id,
          _method: 'delete'
        }).then(() => {
          this.$emit('shotDeleted', {
            id: this.shot.id
          });
        });
      }
    }
  }
};
</script>

<style lang="scss">
  .studio-shot {
    max-width: 350px;
    margin-bottom: 25px;
    .shot-content {
      position: relative;
      background-color: #ffffff;
      border-radius: 3px;
      box-shadow: 0 2px 3px rgba(0, 0, 0, 0.05);
      overflow: hidden;
      .shot-thumbnail {
        position: relative;
        img {
          border-radius: 3px 3px 0 0;
          vertical-align: bottom;
        }
      }
      .shot-toolbar {
        padding: 15px 10px 3px;
      }
    }
  }
</style>